import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { actions as dialogActions } from "@Store/Reducers/dialog";
import i18n from "src/i18n";

const AssistantConversationExportErrorDialogContent: React.FC = () => {
    const { t } = useTranslation();

    return (
        <Box sx={{ py: 1 }}>
            <Typography variant="h6" sx={{ mb: 1 }}>
                {t("pages.eventInsights.assistant.exportErrorDialog.title")}
            </Typography>
            <Typography variant="body2">
                {t("pages.eventInsights.assistant.exportErrorDialog.body")}
            </Typography>
        </Box>
    );
};

const AssistantConversationExportErrorDialogActions: React.FC = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch<any>();

    return (
        <Button
            onClick={() => dispatch(dialogActions.hideDialog())}
            variant="contained"
            size="small"
            color="secondary"
            type="button"
        >
            {t("dialogs.ok")}
        </Button>
    );
};

export default {
    content: AssistantConversationExportErrorDialogContent,
    actions: AssistantConversationExportErrorDialogActions,
    title: i18n.t("pages.eventInsights.assistant.exportErrorDialog.title"),
    disableCancelButton: true,
    isGuestData: false,
};
